import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Input, Form, Space, notification, Select } from 'antd';

import FormHeader from '@controls/form-header/form-header';

import { exception } from '@extensions/notification';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { serverFetch } from '@flc/server';

import { ICargoCarrier } from '@entities/cargo-carrier';
import { IUser } from '@entities/user';
import { IUserFilter } from '@entities/user-filter';

import { CargoCarrierType } from '@enums/cargo-carrier-type';
import { UserType } from '@enums/user-type';

const CargoCarrier = () => {
    const { TextArea } = Input;

    const { id } = useParams();

    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const d = useAppDispatch();

    const [entity, setEntity] = useState<ICargoCarrier>({
        id: undefined,
        name: undefined,
        type: CargoCarrierType.Truck,
    });

    const [loading, setLoading] = useState<boolean>(false);
    const [users, setUsers] = useState<Array<IUser>>([]);

    useEffect(() => {
        let cleanup = false;

        const fetchData = async () => {
            setLoading(true);

            let userFilter: IUserFilter = { isActive: true, isArchived: false, types: [UserType.Carrier] };

            const promises = [
                await serverFetch(`users`, { method: 'GET', queryParams: userFilter })
                    .then((data) => {
                        return data;
                    })
                    .catch((ex) => {
                        exception(api, 'Ошибка получения перевозчика', ex, () => d(userLoaded(undefined)));
                    }),
            ];

            if (id) {
                promises.push(
                    await serverFetch(`cargocarriers/${id}`, { method: 'GET' })
                        .then((data) => {
                            return data;
                        })
                        .catch((ex) => {
                            exception(api, 'Ошибка получения перевозчика', ex, () => d(userLoaded(undefined)));
                        }),
                );
            }

            Promise.all([promises]).then((result) => {
                if (cleanup) return;

                setUsers(result[0][0] || []);
                setEntity(result[0][1] || entity);

                setLoading(false);
            });
        };

        fetchData();
        return () => {
            cleanup = true;
        };
    }, []);

    const onSave = () => {
        setLoading(true);

        serverFetch(`cargocarriers`, { method: entity.id ? 'PUT' : 'POST', bodyData: entity })
            .then(() => {
                setLoading(false);
                navigate(-1);
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка сохранения перевозчика', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <>
            <FormHeader title={id ? 'Изменить перевозчика' : 'Добавить перевозчика'} />
            {!loading && (
                <Form colon={false} labelCol={{ span: 3 }} wrapperCol={{ span: 8 }} onFinish={onSave}>
                    <Form.Item
                        initialValue={entity.name}
                        required
                        label='Название'
                        name='name'
                        rules={[{ required: true, message: 'Укажите название' }]}
                    >
                        <Input
                            onInput={(e) => ((e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toUpperCase())}
                            onChange={(data) => {
                                setEntity({ ...entity, name: data.target.value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item initialValue={entity.inn} label='ИНН' name='inn'>
                        <Input
                            onChange={(data) => {
                                setEntity({ ...entity, inn: data.target.value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item name='userId' label='Собственник' initialValue={entity.userId}>
                        <Select
                            allowClear
                            onChange={(value) => {
                                setEntity({ ...entity, userId: value });
                            }}
                            options={users.map((u) => {
                                return { value: u.id, label: u.fullName };
                            })}
                        />
                    </Form.Item>
                    <Form.Item label='' wrapperCol={{ offset: 3, span: 8 }}>
                        <Space size={'small'} style={{ float: 'right' }}>
                            <Button type='text' onClick={() => navigate(-1)}>
                                Отменить
                            </Button>
                            <Button type='primary' htmlType='submit' loading={loading}>
                                Сохранить
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}

            {contextHolder}
        </>
    );
};

export default CargoCarrier;
